import React, { useEffect, useMemo, useState, useContext } from "react";
import api from "../../../../../services/api";
import EmpresaContext from "../../../../../contexts/Empresa";
import { aplicarVariaveis } from "./index";
import { SITUACOES_SCRIPT } from "../../../../common/ScriptsVenda/constants";

const SITUACAO_COLORS = {
  prospeccao: "#6366f1",
  recepcao_abordagem: "#2dce89",
  sondagem: "#11cdef",
  apresentacao: "#f59e0b",
  objecoes: "#ef4444",
  acompanhamento: "#8b5cf6",
  fechamento: "#10b981",
  pos_venda: "#06b6d4",
  indicacao: "#f97316",
  reativacao: "#fb6340",
  default: "#8898aa",
};

function corDaSituacao(situacao) {
  return SITUACAO_COLORS[situacao] || SITUACAO_COLORS.default;
}

const ScriptCard = ({ titulo, conteudo, tags, telefone, temCanalWhatsapp, onAction }) => {
  return (
    <div
      style={{
        background: "#fff",
        borderRadius: 10,
        padding: 12,
        boxShadow: "0 1px 2px rgba(0,0,0,0.06)",
        border: "1px solid #e5e7eb",
        display: "flex",
        flexDirection: "column",
        gap: 8,
        boxSizing: "border-box",
        overflow: "hidden",
        height: 255,
        minHeight: 255,
        flexShrink: 0,
      }}
    >
      <div
        style={{
          fontSize: 13,
          fontWeight: 700,
          color: "#111827",
          lineHeight: 1.3,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          flexShrink: 0,
        }}
        title={titulo}
      >
        {titulo}
      </div>

      <div
        style={{
          fontSize: 11,
          color: "#6b7280",
          lineHeight: 1.4,
          display: "-webkit-box",
          WebkitLineClamp: 5,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          overflowWrap: "anywhere",
          flex: 1,
          minHeight: 0,
        }}
      >
        {conteudo}
      </div>

      {tags && tags.trim().length > 0 && (
        <div style={{ display: "flex", flexWrap: "wrap", gap: 3 }}>
          {tags.split(",").slice(0, 3).map((t, i) => (
            <span
              key={i}
              style={{
                fontSize: 9,
                padding: "2px 6px",
                borderRadius: 20,
                background: "#f3f4f6",
                color: "#6b7280",
                fontWeight: 500,
              }}
            >
              {t.trim()}
            </span>
          ))}
        </div>
      )}

      <div style={{ display: "flex", gap: 4, marginTop: 2 }}>
        <button
          type="button"
          onClick={() => onAction(conteudo, "copy")}
          style={{
            flex: 1,
            background: "#f3f4f6",
            border: "1px solid #e5e7eb",
            borderRadius: 6,
            padding: "5px 6px",
            fontSize: 11,
            fontWeight: 600,
            color: "#374151",
            cursor: "pointer",
          }}
          title="Copiar"
        >
          <i className="fas fa-copy mr-1" /> Copiar
        </button>
        <button
          type="button"
          onClick={() => onAction(conteudo, "whatsapp")}
          style={{
            flex: 1,
            background: "#1d4ed8",
            color: "#fff",
            border: "none",
            borderRadius: 6,
            padding: "5px 6px",
            fontSize: 11,
            fontWeight: 600,
            cursor: "pointer",
          }}
          title="Abrir no WhatsApp Web"
        >
          <i className="fab fa-whatsapp mr-1" /> Web
        </button>
      </div>

      {temCanalWhatsapp && (
        <button
          type="button"
          onClick={() => telefone && onAction(conteudo, "envio_rapido", telefone)}
          disabled={!telefone}
          style={{
            width: "100%",
            background: telefone ? "#25d366" : "#d1d5db",
            color: "#fff",
            border: "none",
            borderRadius: 6,
            padding: "6px 8px",
            fontSize: 11,
            fontWeight: 600,
            cursor: telefone ? "pointer" : "not-allowed",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 4,
          }}
          title={telefone ? "Enviar diretamente pelo WhatsApp conectado" : "Oportunidade sem telefone cadastrado"}
        >
          <i className="fab fa-whatsapp" /> Envio Rápido
        </button>
      )}
    </div>
  );
};

const Lane = ({ title, barColor, cards, telefone, temCanalWhatsapp, onAction }) => (
  <div
    className="sm-lane"
    style={{
      width: 300,
      minWidth: 300,
      background: "#f4f7fa",
      borderRadius: 8,
      padding: 10,
      display: "flex",
      flexDirection: "column",
      gap: 10,
      height: "100%",
      maxHeight: "100%",
      boxSizing: "border-box",
      overflow: "hidden",
    }}
  >
    <div style={{ flexShrink: 0 }}>
      <div style={{ height: 4, marginBottom: 8, background: barColor, borderRadius: 3 }} />
      <div style={{ fontSize: 13, fontWeight: 700, color: "#344767" }}>{title}</div>
    </div>

    <div
      className="sm-lane-cards"
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 8,
        overflowY: "auto",
        overflowX: "hidden",
        flex: 1,
        minHeight: 0,
        paddingRight: 4,
        scrollBehavior: "smooth",
      }}
    >
      {cards.map((c) => (
        <ScriptCard
          key={c.id}
          titulo={c.tituloOriginal}
          conteudo={c.conteudo}
          tags={c.tags}
          telefone={telefone}
          temCanalWhatsapp={temCanalWhatsapp}
          onAction={onAction}
        />
      ))}
    </div>
  </div>
);

const ScriptsKanban = ({ oportunidade, onAction, temCanalWhatsapp }) => {
  const { empresaSelecionada } = useContext(EmpresaContext);
  const [scripts, setScripts] = useState([]);
  const [loading, setLoading] = useState(false);

  const telefoneCliente = useMemo(() => {
    // Modo lista: telefones é array de objetos { ddd, numero }
    if (Array.isArray(oportunidade?.telefones) && oportunidade.telefones.length > 0) {
      const t = oportunidade.telefones[0];
      const num = t.ddd ? `${t.ddd}${t.numero}` : t.numero;
      return /\d{7,}/.test(num) ? num : "";
    }
    // Modo kanban: telefone é string "DDD+numero, ..."
    const raw = oportunidade?.telefone || "";
    const first = String(raw).split(",")[0].trim();
    return /\d{7,}/.test(first) ? first : "";
  }, [oportunidade?.telefone, oportunidade?.telefones]);

  useEffect(() => {
    if (!empresaSelecionada) return;
    let cancelled = false;
    async function fetchScripts() {
      setLoading(true);
      try {
        const res = await api.get(
          `/common/empresas/${empresaSelecionada.id}/scripts-venda`,
          { params: { page: 1, limit: 200, do_perfil_da_empresa: 1 } }
        );
        if (!cancelled) setScripts(res.data?.data || []);
      } catch (err) {
        console.error("Erro ao carregar scripts do negócio", err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    fetchScripts();
    return () => { cancelled = true };
  }, [empresaSelecionada?.id]);

  const lanes = useMemo(() => {
    return SITUACOES_SCRIPT
      .map((s) => {
        const cards = scripts
          .filter((sc) => sc.situacao === s.value)
          .map((sc) => ({
            id: String(sc.id),
            tituloOriginal: sc.titulo,
            conteudo: aplicarVariaveis(sc.conteudo || "", oportunidade),
            tags: sc.tags || "",
          }));
        return {
          id: s.value,
          title: `${s.label} (${cards.length})`,
          barColor: corDaSituacao(s.value),
          cards,
        };
      })
      .filter((lane) => lane.cards.length > 0);
  }, [scripts, oportunidade]);

  if (loading) {
    return (
      <div style={{ padding: 24, textAlign: "center", color: "#9ca3af" }}>
        Carregando scripts...
      </div>
    );
  }

  if (lanes.length === 0) {
    return (
      <div style={{ padding: 24, textAlign: "center", color: "#9ca3af" }}>
        Nenhum script cadastrado para o perfil de negócio desta empresa.
      </div>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        gap: 12,
        overflowX: "auto",
        overflowY: "hidden",
        height: "100%",
        paddingBottom: 8,
        alignItems: "stretch",
      }}
    >
      {lanes.map((lane) => (
        <Lane
          key={lane.id}
          title={lane.title}
          barColor={lane.barColor}
          cards={lane.cards}
          telefone={telefoneCliente}
          temCanalWhatsapp={temCanalWhatsapp}
          onAction={onAction}
        />
      ))}
    </div>
  );
};

export default ScriptsKanban;
